import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setMessage } from "./message";

import AuthService from "../services/upperfooter.service";

export const addUpperFooter = createAsyncThunk(
  "upper/add", async ({ title, description, image, type, url }, thunkAPI) => {

    try {
      const data = await AuthService.addUpperFooter(title, description, image, type, url);
      thunkAPI.dispatch(setMessage(data.message));
      return true;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const getUpperFooter = createAsyncThunk(
  "upper/get", async (thunkAPI) => {

    try {
      const data = await AuthService.getUpperFooter();
      return data.docs;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const updateUpperFooter = createAsyncThunk(
  "upper/updateInfo", async ({ id, title, description, image, type, url, oldImage }, thunkAPI) => {
    try {
      const data = await AuthService.updateUpperFooter(id, title, description, image, type, url, oldImage);
      thunkAPI.dispatch(setMessage(data.message));
      return data.docs;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  });

export const deleteUpperFooter = createAsyncThunk(
  "upper/delete", async (id, thunkAPI) => {
    try {
      const data = await AuthService.deleteUpperFooter(id);
      thunkAPI.dispatch(setMessage(data.message));
      return data.docs;
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }

);

const initialState = { isLoader: false, upperfoot: null };

const upperFooterSlice = createSlice({
  name: "upper",
  initialState,
  extraReducers: {
    [addUpperFooter.fulfilled]: (state, action) => {
      state.isLoader = false;
      state.upperfoot = null
    },
    [addUpperFooter.rejected]: (state, action) => {
      state.isLoader = false;
      state.upperfoot = null
    },
    [getUpperFooter.fulfilled]: (state, action) => {
      state.isLoader = false;
      state.upperfoot = action.payload
    },
    [getUpperFooter.rejected]: (state, action) => {
      state.isLoader = false;
      state.upperfoot = null
    },
    [updateUpperFooter.fulfilled]: (state, action) => {
      state.isLoader = false;
      state.upperfoot = action.payload
    },
    [updateUpperFooter.rejected]: (state, action) => {
      state.isLoader = false;
      state.upperfoot = null
    },
    [updateUpperFooter.fulfilled]: (state, action) => {
      state.isLoader = false;
      state.upperfoot = action.payload
    },
    [updateUpperFooter.rejected]: (state, action) => {
      state.isLoader = false;
      state.upperfoot = null
    },
    [deleteUpperFooter.fulfilled]: (state, action) => {
      state.isLoader = false;
      state.upperfoot = action.payload
    },
    [deleteUpperFooter.rejected]: (state, action) => {
      state.isLoader = false;
      state.upperfoot = null
    }
  },
});

const { reducer } = upperFooterSlice;
export default reducer;